import React from 'react';

export default function AdminManagement() {
  return (
    <div className="family-tree-container">
      <h1 className="page-title">Admin Management</h1>
      <p className="text-gray-600">Manage family admins from this section.</p>
    </div>
  );
}
